import { SET_PROFILE,LOGOUT ,ADD_TRIAL} from './actiontypes';
import {axiosIntance} from '../components/API/Base';



export const setProfile = (userProfile) => {
    return {
        type: SET_PROFILE,
       userProfile
    }
}

export const login = (userInfo) => {
    return dispatch => {
        axiosIntance.post('users/login', userInfo)
        .then(response => {
            dispatch(setProfile(response.data.data));
        })
        .catch(err => { 
            console.log(err);
        
        });
    };
};

export const Logout = () => {
    return {
        type: LOGOUT,
    }
}

export const addTrial = (license) => {
    return {
        type: ADD_TRIAL,
        license
    }
}
